import { useQuery } from "@tanstack/react-query";
import { listParticipationInApplicationProcessByCandidateId } from "../openapi/api-client.ts";

export const useListParticipationInApplicationProcessByCandidateId = (
  candidateId?: string,
) =>
  useQuery({
    queryKey: ["listParticipationInApplicationProcess", { candidateId }],
    queryFn: async () => {
      if (!candidateId) {
        throw new Error("candidateId not set");
      }

      const response = await listParticipationInApplicationProcessByCandidateId(
        {
          candidateId,
        },
      );

      if (!response.data) {
        throw new Error("no data given");
      }

      return response.data;
    },
    enabled: !!candidateId,
  });
